import { useMemo } from "react";

import type { InSaleAndStopSellingItemsType } from "../../../../_shared";
import type { ServerModel } from "../../../model/usecase/use-create-form-model/type";

type Props = {
	serverModel: ServerModel;
};

export const useCreateInSaleAndStopSellingFilterProps = ({ serverModel }: Props) => {
	const { items } = serverModel.optionStock;

	const inSaleItems: InSaleAndStopSellingItemsType = useMemo(
		() =>
			items
				.filter((item) => item.isInSale && !item.subOptionID)
				.map((item) => {
					return { id: item.optionID, name: item.name };
				}),
		[items],
	);

	const stopSellingItems: InSaleAndStopSellingItemsType = useMemo(
		() =>
			items
				.filter((item) => !item.isInSale && !item.subOptionID)
				.map((item) => {
					return { id: item.optionID, name: item.name };
				}),
		[items],
	);

	return {
		itemsName: "オプション" as const,
		inSaleItems,
		stopSellingItems,
	};
};
